
import type { User } from "firebase/auth"
import { useForm } from "react-hook-form"
import type { SpaceKey } from "popopo-msg"
import { api } from "../../core"
import { useToast } from "popopo-lib-front/hook"

type SpaceUpdateForms = {
  name: string
}

export const SpaceUpdateForm = (props: { firebase: User; spaceKey: SpaceKey }) => {
  const form = useForm<SpaceUpdateForms>({
    mode: "onBlur",
    defaultValues: {
      name: "update space: " + new Date().toISOString(),
    },
  })
  const toast = useToast()
  const { isSubmitting, isValid } = form.formState

  const onSubmit = async (value: SpaceUpdateForms) => {
    try {
      const idToken = await props.firebase.getIdToken()
      const res = await api.PUT("/api/v2/spaces/{space_key}", {
        params: { path: { space_key: props.spaceKey } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        body: value,
      })
      if (res.data == null) {
        toast.add({ type: "danger", title: "スペース更新", message: JSON.stringify(res.error) })
      }
    } catch (e) {
      console.error(e)
      toast.add({ type: "danger", title: "スペース更新", message: e.message })
      throw e
    }
  }

  const onDelete = async () => {
    try {
      const idToken = await props.firebase.getIdToken()
      const res = await api.DELETE("/api/v2/spaces/{space_key}", {
        params: { path: { space_key: props.spaceKey } },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
      })
      if (res.data == null) {
        toast.add({ type: "danger", title: "スペース削除", message: JSON.stringify(res.error) })
      }
    } catch (e) {
      console.error(e)
      toast.add({ type: "danger", title: "スペース削除", message: e.message })
      throw e
    }
  }

  return (
    <>
      <form className="d-flex w-100 flex-column gap-3" onSubmit={form.handleSubmit(onSubmit)}>
        <div className="form-floating">
          <input className="form-control" {...form.register("name")} disabled={isSubmitting} />
          <label>Name</label>
        </div>

        <button type="submit" className="btn btn-primary form-control" disabled={isSubmitting || !isValid}>
          Call &quot;PUT /spaces/:spaceKey&quot; API
        </button>
      </form>
      <div className="d-flex w-100 flex-column gap-3">
        <button type="button" className="btn btn-danger form-control" onClick={onDelete}>
          Call &quot;DELETE /spaces/:spaceKey&quot; API
        </button>
      </div>
    </>
  )
}
